export const iconFontAwesomeLogisticsBusSimple = (
	<i className="fa-solid fa-bus-simple"></i>
);
